export const MAGAZINE_LOG_EVENT = {
  CLICK_PREV_MAGAZINE: 'click_prev_magazine',
  CLICK_NEXT_MAGAZINE: 'click_next_magazine',
  UPPER_MAGAZINE_SHARE_CLICK: 'upper_magazine_share_click',
  CLICK_MAGAZINE_TAG: 'click_magazine_tag',
  MOVE_TO_SEARCH_PAGE_CLICK: 'move_to_search_page_click',
  CLICK_MOVE_CTA_LINK: 'click_move_cta_link',
  CLICK_MOVE_HOSPITAL_FROM_MAGAZINE: 'click_move_hospital_from_magazine',
  CLICK_MOVE_HOSPITAL_FROM_CTA: 'click_move_hospital_from_cta',
  HEALTH_TIP_DETAIL_STICKY_BUTTON_CLICK: 'health_tip_detail_sticky_button_click',
  CLICK_MAGAZINE_TOC: 'click_magazine_toc',
  MAGAZINE_ITEM_CLICK: 'magazine_item_click',
  MAGAZINE_RELATED_QNA_CLICK: 'magazine_related_qna_click',
  MAGAZINE_RELATED_BOARD_POST_CLICK: 'magazine_related_board_post_click',
  CLICK_OUTER_LINK: 'click_outer_link',
} as const;
